module.exports = __webpack_public_path__ + "img/Eye.bfdace62.svg";